import React from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import useMediaQuery from 'react-use-media-query-hook';

import { Trash2 } from 'lucide-react';
import ProgressBar from '../../components/ProgressBar';
import { calculateProgress } from '../../utils/helpers';
import Button from '../../components/Button';
import Img from '../../components/Img';
import ConfirmationModal from '../../components/ConfirmationModal';
import * as AppRoute from '../../utils/appRoutes';

export default function Card({
  className,
  card,
  pickIdeaMode = false,
  showEditButton = false,
  picked,
  onPick,
  locales,
  bmc,
  removeIdea,
}) {
  const isMobile = useMediaQuery('(max-width: 480px)');
  const history = useHistory();
  const {
    id,
    url,
    problemTitle,
    problem,
    solutionTitle,
    solution,
    marketSizeTitle,
    marketSize = 0,
    priceTitle,
    price = 0,
    excitementTitle,
    excitement = 0,
    pickThisIdea,
    pickedWord,
    editIdea,
    deleteIdea,
  } = card;
  const { areYouSure, deleteText } = locales.common;
  const bmcId = bmc.id;

  return (
    <div
      className={classNames('ideation-card', className, {
        'ideation-card--pick-idea': pickIdeaMode,
        'ideation-card--picked': picked,
      })}
      onClick={() => isMobile && history.push(AppRoute.ideation(bmcId, id))}
    >
      {/* {showEditButton && removeIdea && (
        <ConfirmationModal
          className="hover:bg-muted-lighter/60 text-muted-darker"
          body={areYouSure}
          confirmText={deleteText}
          onConfirm={() => removeIdea({ id })}
          buttonAriaLabel="Delete"
        >
          <Trash2 className="w-6 min-w-6 h-auto" />
        </ConfirmationModal>
      )} */}
      <div className="ideation-card-left">
        {url ? (
          <Img src={url} alt="ideation-card" aspectRatio={1} />
        ) : (
          <div className="ideation-card-default-image" />
        )}
      </div>

      <div className="ideation-card-right">
        {!pickIdeaMode && (
          <>
            <div className="ideation-card-title margin-bottom-10">
              {problemTitle}
            </div>

            <div className="ideation-card-text margin-bottom-20">{problem}</div>

            <div className="ideation-card-title margin-bottom-10">
              {solutionTitle}
            </div>
          </>
        )}

        <div className="ideation-card-text margin-bottom-20">{solution}</div>

        {pickIdeaMode && <div className="margin-top-40" />}

        <ProgressBar
          title={marketSizeTitle}
          value={marketSize}
          progress={calculateProgress(marketSize, 10)}
          className="bmc-progressbar--green margin-bottom-10"
        />
        <ProgressBar
          title={priceTitle}
          value={price}
          progress={calculateProgress(price, 10)}
          className="bmc-progressbar--orange margin-bottom-10"
        />
        <ProgressBar
          title={excitementTitle}
          value={excitement}
          progress={calculateProgress(excitement, 10)}
          className="bmc-progressbar--violet"
        />

        {pickIdeaMode && (
          <div className="ideation-card-actions margin-top-20">
            {picked ? (
              <Button variant="outline">{pickedWord}</Button>
            ) : (
              <Button variant="outline" onClick={onPick}>
                {pickThisIdea}
              </Button>
            )}
          </div>
        )}

        {showEditButton && (
          <div className="ideation-card-actions margin-top-40 flex flex-row gap-2">
            {removeIdea && (
              <>
                <ConfirmationModal
                  className="font-medium disabled:pointer-events-none disabled:opacity-60 border-2 border-solid border-destructive-muted hover:border-solid hover:border-destructive bg-destructive-text text-destructive py-2.5 px-5"
                  body={areYouSure}
                  confirmText={deleteText}
                  onConfirm={() => removeIdea({ id })}
                  buttonAriaLabel="Delete"
                >
                  <Trash2 className="w-6 min-w-6 h-auto" />
                  {deleteIdea}
                </ConfirmationModal>

                <Button
                  variant="outline"
                  onClick={() => history.push(AppRoute.ideation(bmcId, id))}
                >
                  {editIdea}
                </Button>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
